import script from "./EditVideoCaptionSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditVideoCaptionSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./EditVideoCaptionSidebar.vue?vue&type=style&index=0&id=0a762ce9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a762ce9"]])

export default __exports__